import { Loan } from '@nemuru-eng/js-api-client';
import { SWRConfig } from 'swr';

import { UseDialogProps } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/LoanApplicationActionDialog';
import { AddParticipantToLoanDialog } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/AddParticipantToLoanDialog';
import { ChangeLoanConditionsDialog } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/ChangeLoanConditionsDialog/ChangeLoanConditionsDialog';
import { LoanStatusChangeMessageConfirmation } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/LoanStatusChangeMessageConfirmation';
import { OptOutNotificationsDialog } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/OptOutNotificationsDialog';
import { RemoveParticipantFromLoanDialog } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/RemoveParticipantFromLoanDialog';
import { UpdateLoanApplicationInLenderDialog } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/UpdateLoanApplicationInLenderDialog';
import { LoanStatusChangeActions } from '@/components/widgets/LoanDetailActions/constants/LoanStatusChangeActions';
import { LoanDetailAction } from '@/components/widgets/LoanDetailActions/types/LoanDetailAction';

interface LoanDetailActionsDialogProps {
  loan: Loan;
  currentAction: LoanDetailAction;
  useDialogProps: UseDialogProps;
}

export const LoanDetailActionsDialog = ({ loan, currentAction, useDialogProps }: LoanDetailActionsDialogProps) => {
  const { opened, setOpened, toggleDialog } = useDialogProps;

  return (
    <>
      <SWRConfig value={{ revalidateOnMount: false }}>
        {currentAction === LoanDetailAction.ADD_PARTICIPANT_TO_LOAN && (
          <AddParticipantToLoanDialog loan={loan} opened={opened} setOpened={setOpened} handleClose={toggleDialog} />
        )}
        {currentAction === LoanDetailAction.REMOVE_PARTICIPANT_FROM_LOAN && (
          <RemoveParticipantFromLoanDialog
            loan={loan}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {LoanStatusChangeActions.some((action) => action === currentAction) && (
          <LoanStatusChangeMessageConfirmation
            loan={loan}
            currentAction={currentAction}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {currentAction === LoanDetailAction.UPDATE_LOAN_APPLICATION_IN_LENDER && (
          <UpdateLoanApplicationInLenderDialog
            loan={loan}
            opened={opened}
            setOpened={setOpened}
            handleClose={toggleDialog}
          />
        )}
        {currentAction === LoanDetailAction.CHANGE_LOAN_CONDITIONS && (
          <ChangeLoanConditionsDialog loan={loan} opened={opened} setOpened={setOpened} handleClose={toggleDialog} />
        )}
        {currentAction === LoanDetailAction.OPT_OUT_NOTIFICATIONS && (
          <OptOutNotificationsDialog opened={opened} setOpened={setOpened} handleClose={toggleDialog} />
        )}
      </SWRConfig>
    </>
  );
};
